module.exports = __webpack_public_path__ + "static/media/yoga-retreat-banner-desktop.b7f7c9b6.jpg";